import { Movie, Star, User } from '@usheru-hff/shared/domain';
import { SearchItemType } from '@usheru-hff/shared/domain';

export const isStar = (item: SearchItemType) => {
  return (item as Star).name !== undefined;
};
export const isMovie = (item: SearchItemType) => {
  return (item as Movie).friendlyUrl !== undefined;
};
export const isUser = (item: SearchItemType) => {
  return (item as User).username !== undefined;
};
